import Container from './edit-office-container';

export default Container;
